<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="lss"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({status:1})" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.lss">
            <template #idx>
              <span>{{item.idx}}</span>
            </template>
          </i18n>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="lss_errors"
              :label="$t('fields.name')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>
            <v-text-field
              v-model="item.domen"
              :label="$t('fields.domen')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
            <v-text-field v-model="item.ip" :label="$t('fields.ip')"></v-text-field>
            <v-text-field v-model="item.port" :label="$t('fields.port')"></v-text-field>
            <v-file-input
              v-model="keyfile"
              :label="$t('fields.keyfile')"
              :placeholder="item.keyfile"
              clearable
              @click:clear="item.keyfile=null"
            ></v-file-input>
            <v-text-field v-model="item.keypass" :label="$t('fields.keypass')"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm=true" color="primary">{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog v-model="d_confirm" :mode="dmode" @click:ok="remove">{{$t("dialog.txt.delLss")}}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";

export default {
  name: "AdminLSS",
  mixins: [commonmixin],
  data() {
    return {
      item: {},
      d_edit: false,
      lss_errors: "",
      keyfile: null,
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
        { text: this.$t("fields.name"), value: "name" },
        { text: this.$t("fields.domen"), value: "domen" },
        { text: this.$t("fields.ip"), value: "ip" },
        { text: this.$t("fields.port"), value: "port" },
        { text: this.$t("fields.keyfile"), value: "keyfile" },
        //        { text: this.$t("fields.keypass"), value: "keypass" },
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
      ],
    };
  },
  computed: {
    lss() {
      return this.$store.getters["admin/lsservers"];
    },
  },
  methods: {
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.lss.indexOf(i);
      this.keyfile = null;
    },
    remove() {
      this.$store.dispatch("admin/DELETE_LSS", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_LSS", {
            item: this.item,
            index: this.currentIdx,
            file: this.keyfile,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        this.$store
          .dispatch("admin/INSERT_LSS", {
            item: this.item,
            file: this.keyfile,
          })
          .then((response) => {
            if (response == 0) {
              this.filial_errors = this.$t("error.api");
            } else {
              this.d_edit = false;
            }
          });
      }
    },
  },
  mounted() {
    this.$store.dispatch("admin/LOAD_LSS");
  },
};
</script>

<style scoped>
</style>